<template>
	<div class="favorite-message-item" :class="{ active: active, selected: selected }" @click="$emit('click', favorite)"
		@contextmenu.prevent="showMenu($event)">
		<el-checkbox v-if="selectMode" class="check-box" :value="selected" @click.native.stop=""
			@change="val => $emit('select-change', favorite, val)"></el-checkbox>
		<div class="item-body">
			<div class="item-content">
				<span class="message-text" v-if="favorite.messageType == $enums.MESSAGE_TYPE.TEXT"
					v-html="htmlText"></span>
				<div class="message-image" v-else-if="favorite.messageType == $enums.MESSAGE_TYPE.IMAGE">
					<img class="send-image" :src="contentData.thumbUrl" loading="lazy" @click.stop="showFullImage()" />
				</div>
				<div class="message-image" v-else-if="favorite.messageType == $enums.MESSAGE_TYPE.STICKER">
					<img class="send-image" :src="contentData.imageUrl" loading="lazy" />
				</div>
				<div class="message-video" v-else-if="favorite.messageType == $enums.MESSAGE_TYPE.VIDEO"
					@click.stop="onClickVideo">
					<video v-if="!pickMode" class="send-video" controls preload="none" :poster="contentData.coverUrl"
						:src="contentData.videoUrl" />
					<img v-else class="send-video-cover" :src="contentData.coverUrl" loading="lazy" />
				</div>
				<div class="message-file" v-else-if="favorite.messageType == $enums.MESSAGE_TYPE.FILE"
					@click.stop="onPreviewFile">
					<div class="file-main">
						<div class="file-info">
							<div class="file-name">{{ contentData.name }}</div>
							<div class="file-meta" v-if="fileSizeText">{{ fileSizeText }}</div>
						</div>
						<span class="el-icon-document file-icon"></span>
					</div>
				</div>
				<div class="message-voice message-text" v-else-if="favorite.messageType == $enums.MESSAGE_TYPE.AUDIO"
					@click.stop="onPlayVoice">
					<span>{{ $t('chat.previewVoice') }} {{ contentData.duration }}"</span>
					<i v-if="audioPlayState === 'PLAYING'" class="el-icon-video-pause play-state"></i>
					<i v-else-if="audioPlayState === 'PAUSE'" class="el-icon-video-play play-state"></i>
				</div>
				<div class="message-text message-merge-forward" v-else-if="favorite.messageType == $enums.MESSAGE_TYPE.MERGE_FORWARD"
					@click.stop="onClickMergeForward">
					{{ $t('chat.mergeForwardCount', { n: mergeForwardCount }) }}
				</div>
				<div class="message-text" v-else>{{ previewText }}</div>
			</div>
			<div class="item-footer">
				<span class="chat-name">{{ $t('favorite.fromChat', { name: favorite.chatName }) }}</span>
				<span class="time">{{ $date.toTimeText(favorite.createTime) }}</span>
			</div>
		</div>
		<right-menu ref="rightMenu" @select="onSelectMenu"></right-menu>
		<chat-merge-forward ref="mergeForward"></chat-merge-forward>
	</div>
</template>

<script>
import RightMenu from '../common/RightMenu.vue';
import ChatMergeForward from '../chat/ChatMergeForward.vue';

export default {
	name: 'FavoriteMessageItem',
	components: {
		RightMenu,
		ChatMergeForward
	},
	props: {
		favorite: {
			type: Object,
			required: true
		},
		active: {
			type: Boolean,
			default: false
		},
		selected: {
			type: Boolean,
			default: false
		},
		selectMode: {
			type: Boolean,
			default: false
		},
		pickMode: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			audioPlayState: 'STOP',
			audioEl: null
		};
	},
	computed: {
		contentData() {
			if (this.favorite.messageType == this.$enums.MESSAGE_TYPE.TEXT) {
				return {};
			}
			try {
				return JSON.parse(this.favorite.content);
			} catch (e) {
				return {};
			}
		},
		fileSizeText() {
			let size = this.contentData.size;
			if (!size) {
				return '';
			}
			if (size > 1024 * 1024) {
				return (size / 1024 / 1024).toFixed(1) + 'M';
			}
			if (size > 1024) {
				return (size / 1024).toFixed(1) + 'KB';
			}
			return size + 'B';
		},
		htmlText() {
			let text = this.$str.html2Escape(this.favorite.content);
			text = this.$url.replaceURLWithHTMLLinks(text, '');
			return this.$emo.transform(text, 'emoji-normal');
		},
		mergeForwardCount() {
			try {
				return JSON.parse(this.favorite.content).messages.length;
			} catch (e) {
				return 0;
			}
		},
		previewText() {
			const type = this.favorite.messageType;
			const map = {
				[this.$enums.MESSAGE_TYPE.IMAGE]: this.$t('chat.previewImage'),
				[this.$enums.MESSAGE_TYPE.VIDEO]: this.$t('chat.previewVideo'),
				[this.$enums.MESSAGE_TYPE.FILE]: this.$t('chat.previewFile'),
				[this.$enums.MESSAGE_TYPE.AUDIO]: this.$t('chat.previewVoice'),
				[this.$enums.MESSAGE_TYPE.USER_CARD]: this.$t('chat.previewUserCard'),
				[this.$enums.MESSAGE_TYPE.GROUP_CARD]: this.$t('chat.previewGroupCard'),
				[this.$enums.MESSAGE_TYPE.STICKER]: this.$t('chat.previewSticker')
			};
			return map[type] || this.$t('chat.unsupportedType');
		}
	},
	methods: {
		showFullImage() {
			if (this.pickMode) {
				this.$emit('click', this.favorite);
				return;
			}
			const imageUrl = this.contentData.originUrl || this.contentData.thumbUrl;
			if (imageUrl) {
				this.$eventBus.$emit('openFullImage', imageUrl);
			}
		},
		onClickVideo() {
			if (this.pickMode) {
				this.$emit('click', this.favorite);
			}
		},
		onPreviewFile() {
			if (this.pickMode) {
				this.$emit('click', this.favorite);
				return;
			}
			if (this.contentData.url) {
				this.$eventBus.$emit('openPreviewFile', this.contentData.url);
			}
		},
		onPlayVoice() {
			if (this.pickMode) {
				this.$emit('click', this.favorite);
				return;
			}
			const url = this.contentData.url;
			if (!url) {
				return;
			}
			if (this.audioPlayState === 'STOP') {
				if (this.audioEl) {
					this.audioEl.pause();
				}
				this.audioEl = new Audio(url);
				this.audioEl.onended = () => {
					this.audioPlayState = 'STOP';
				};
				this.audioEl.onerror = () => {
					this.audioPlayState = 'STOP';
				};
				this.audioEl.play();
				this.audioPlayState = 'PLAYING';
			} else if (this.audioPlayState === 'PLAYING') {
				this.audioEl.pause();
				this.audioPlayState = 'PAUSE';
			} else if (this.audioPlayState === 'PAUSE') {
				this.audioEl.play();
				this.audioPlayState = 'PLAYING';
			}
		},
		onClickMergeForward() {
			if (this.pickMode) {
				this.$emit('click', this.favorite);
				return;
			}
			if (this.contentData && this.contentData.messages) {
				this.$refs.mergeForward.open(this.contentData);
			}
		},
		showMenu(e) {
			if (this.selectMode || this.pickMode) {
				return;
			}
			const menuItems = [
				{ key: 'LOCATE', name: this.$t('chat.locateInChat') },
				{ key: 'FORWARD', name: this.$t('chat.forward') },
				{ key: 'MULTI_SELECT', name: this.$t('chat.multiSelect') },
				{ key: 'UNFAVORITE', name: this.$t('favorite.unfavorite'), danger: true }
			];
			this.$refs.rightMenu.open(e, menuItems);
		},
		onSelectMenu(item) {
			const eventKey = item.key.toLowerCase().replace(/_([a-z])/g, (_, c) => c.toUpperCase());
			this.$emit(eventKey, this.favorite);
		}
	},
	beforeDestroy() {
		if (this.audioEl) {
			this.audioEl.pause();
			this.audioEl = null;
		}
	}
}
</script>

<style lang="scss" scoped>
.favorite-message-item {
	display: flex;
	align-items: flex-start;
	gap: 10px;
	padding: 15px;
	background: white;
	border-radius: 8px;
	border: 1px solid #f0f0f0;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
	cursor: pointer;
	transition: all 0.2s ease;

	&:hover {
		border-color: rgba(62, 69, 215, 0.2);
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
	}

	&.selected {
		border-color: var(--im-color-primary);
		background: var(--im-background-active);
		box-shadow: 0 0 0 1px rgba(62, 69, 215, 0.12);
	}

	.check-box {
		margin-top: 2px;
	}

	.item-body {
		flex: 1;
		min-width: 0;
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		text-align: left;
	}

	.item-content {
		width: 100%;
		text-align: left;

		.message-text {
			font-size: var(--im-font-size);
			color: var(--im-text-color);
			word-break: break-word;
			text-align: left;
			line-height: 1.5;
		}

		.message-image {
			.send-image {
				max-width: 100px;
				max-height: 100px;
				border-radius: 6px;
				display: block;
			}
		}

		.message-video {
			.send-video {
				max-width: 200px;
				max-height: 140px;
				border-radius: 6px;
				display: block;
			}

			.send-video-cover {
				max-width: 200px;
				max-height: 140px;
				border-radius: 6px;
				display: block;
				object-fit: cover;
			}
		}

		.message-file {
			width: 100%;
			cursor: pointer;

			.file-main {
				display: flex;
				align-items: center;
				justify-content: space-between;
				gap: 20px;
			}

			.file-info {
				flex: 1;
				min-width: 0;
				text-align: left;

				.file-name {
					font-size: var(--im-font-size);
					line-height: 1.45;
					color: var(--im-text-color);
					word-break: break-all;
				}

				.file-meta {
					margin-top: 4px;
					font-size: var(--im-font-size-smaller);
					color: var(--im-text-color-light);
				}
			}

			.file-icon {
				font-size: 32px;
				color: #d42e07;
				flex-shrink: 0;
			}
		}

		.message-voice {
			display: flex;
			align-items: center;
			gap: 8px;
			cursor: pointer;

			.play-state {
				font-size: 16px;
				color: var(--im-color-primary);
			}
		}

		.message-merge-forward {
			cursor: pointer;
		}
	}

	.item-footer {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 12px;
		margin-top: 8px;
		padding-top: 8px;
		width: 100%;
		border-top: 1px solid #f5f5f5;
		text-align: left;

		.chat-name {
			flex: 1;
			min-width: 0;
			font-size: var(--im-font-size-small);
			color: var(--im-text-color-light);
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}

		.time {
			font-size: var(--im-font-size-smaller);
			color: var(--im-text-color-light);
			flex-shrink: 0;
		}
	}
}
</style>
